<template>
  <ContentContainer class="py-[42px] lg:py-21 in-[.basic-page-body]:p-0!">
    <div class="block px-4 lg:px-0">
      <slot name="ckeditor" />
    </div>
  </ContentContainer>
</template>

<script setup lang="ts">
defineSlots<{
  ckeditor(): string[] | string;
}>();
</script>
